module.exports = __webpack_public_path__ + "static/media/file-pdf.f4a2ad1e.svg";